import { WhiskyDB } from "./db";
import { UTFUtil } from "./UtfToStr";
import { User } from "../providers/user";
import { ToastController } from "ionic-angular/components/toast/toast-controller";
import { Storage } from "@ionic/storage/dist/storage";

declare var AWS: any;
declare const aws_user_files_s3_bucket;
declare const aws_user_files_s3_bucket_region;

export class WhiskySync {
  me: any;
  user: User;
  storage: Storage;
  toastCtrl: ToastController;

  startAutoSync(storage: Storage, user: User, toast: ToastController) {
    this.user = user;
    this.storage = storage;
    this.toastCtrl = toast;
    this.loadFromCloud(this);
  }

  saveToCloud(parent) {
    this.me = parent;
    let me = parent;

    if (!WhiskyDB.networkUp) {
      if (me.alertCtrl) {
        let alert = me.alertCtrl.create({
          title: "Network down",
          message: "Please try again when the network is up",
          buttons: ["Dismiss"]
        });
        alert.present();
      } else {
        me.toastCtrl.create({
          message: "Unable to sync, network down",
          duration: 3000
        });
      }
      return;
    }

    let toSave = WhiskyDB.db.getAllData();
    let loading = me.loadingCtrl.create({ content: "Saving" });
    loading.present();

    let s3 = new AWS.S3({
      params: {
        Bucket: aws_user_files_s3_bucket
      },
      region: aws_user_files_s3_bucket_region
    });

    let sub = AWS.config.credentials.identityId;
    me.user.getUser().getUserAttributes((err, data) => {
      if (err) {
        console.log(err);
        let toast = me.toastCtrl.create({
          message: "Error connecting, network down?",
          duration: 3000
        });
        toast.present();
        loading.dismiss();
        return;
      }
      let attributes = data;
      console.log("attributes: " + attributes);
    });

    s3
      .upload({
        Key: "protected/" + sub + "/whiskydb.json",
        Body: toSave,
        ContentType: "application/json"
      })
      .promise()
      .then(
        data => {
          loading.dismiss();
          console.log("Data saved: " + toSave.length);
          let toast = me.toastCtrl.create({
            message: "Done saving database",
            duration: 3000
          });
          toast.present();
        },
        err => {
          loading.dismiss();
          if (me.alertCtrl) {
            let alert = me.alertCtrl.create({
              title: "Error Saving",
              message: err ? err : "Record not found",
              buttons: ["Dismiss"]
            });
            alert.present();
          } else {
            let toast = me.toastCtrl.create({
              message: "Error Saving: " + (err ? err : " network error."),
              duration: 3000
            });
            toast.present();
          }
        }
      );
  }

  loadFromCloud(parent) {
    let me = parent;
    this.me = parent;
    let alerts = me.alertCtrl;
    let events = me.events;
    let toaster = me.toastCtrl;

    console.log("alert: " + me.alertCtrl);
    console.log("toast: " + me.toastCtrl);
    if (!WhiskyDB.networkUp) {
      if (me.alertCtrl) {
        let alert = me.alertCtrl.create({
          title: "Network down",
          message: "Please try again when the network is up",
          buttons: ["Dismiss"]
        });
        alert.present();
      } else {
        let toast = me.toastCtrl.create({
          message: "Network down, unable to loads.",
          duration: 3000
        });
        toast.present();
      }
      return;
    }
    var loading: any;

    if(me.loadingCtrl) {
      loading = me.loadingCtrl.create({ content: "Loading" });
      loading.present();
    }
    let s3 = new AWS.S3({
      params: {
        Bucket: aws_user_files_s3_bucket
      },
      region: aws_user_files_s3_bucket_region
    });

    let sub = AWS.config.credentials.identityId;
    me.user.getUser().getUserAttributes((err, data) => {
      if (err) {
        console.log(err);
        let toast = me.toastCtrl.create({
          message: "Error connecting, network down?",
          duration: 3000
        });
        toast.present();
        if(loading)
          loading.dismiss();
        return;
      }
      let attributes = data;
      console.log("attributes: " + attributes);
    });

    s3.getObject(
      {
        Bucket: aws_user_files_s3_bucket,
        Key: "protected/" + sub + "/whiskydb.json"
      },
      function(err, data) {
        if (err) {
          console.log(err);
          if (me.alertCtrl) {
            let alert = me.alertCtrl.create({
              title: "Error Loading",
              message: err ? err : "Record not found",
              buttons: ["Dismiss"]
            });
            if(loading)
              loading.dismiss();
            alert.present();
          } else {
            let toast = me.toastCtrl.create({
              message: "Error connecting, network down?",
              duration: 3000
            });
            toast.present();
            if(loading)
              loading.dismiss();
          }
        } else {
          console.log(data.Body.length);
          var converted = UTFUtil.Utf8ArrayToStr(data.Body);

          console.log("Bytes read: " + converted.length);
          if(loading)
            loading.dismiss();

          let toast = toaster.create({
            message: "Done loading database",
            duration: 3000
          });

          toast.present();
          WhiskyDB.db.loadAllData(converted, alerts, toaster);

          console.log("Database loaded");
          events.publish("bottlers:updated");
          events.publish("shelves:updated");
          events.publish("ratings:updated");
          events.publish("distilleries:updated");
          events.publish("whiskies:updated");
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/data/sync.ts